module.exports = __webpack_public_path__ + "img/template_3.f42b230d.png";